import { cryptoRandomUUID } from '@finxone-platform/shared/sys-config-types';

const labelTextSkeleton = (widthClass: string) => `
<span class="labelText skeleton_item ${widthClass}">
  <span class="skeleton_item"></span>
</span>
`;

export const exchangeQuoteSkeleton = {
  id: cryptoRandomUUID().toString(),
  quoteId: labelTextSkeleton('skeleton_50'),
  exchangeRate: labelTextSkeleton('skeleton_50'),
  buyCurrency: labelTextSkeleton('skeleton_50'),
  buyAmount: labelTextSkeleton('skeleton_50'),
  sellCurrency: labelTextSkeleton('skeleton_50'),
  sellAmount: labelTextSkeleton('skeleton_50'),
  feeAmount: labelTextSkeleton('skeleton_50'),
  feeCurrency: labelTextSkeleton('skeleton_50'),
  exchangeDate: labelTextSkeleton('skeleton_50'),
  expiryDateTime: labelTextSkeleton('skeleton_50'),
  cutOffTimeInMinutes: labelTextSkeleton('skeleton_50'),
  fixedSide: labelTextSkeleton('skeleton_50'),
  settlementDate: labelTextSkeleton('skeleton_50'),
  debitAmount: labelTextSkeleton('skeleton_50'),
  creditAmount: labelTextSkeleton('skeleton_50'),
  exchangeQuote: {
    id: cryptoRandomUUID().toString(),
    feeAmountPlusSellAmount: labelTextSkeleton('skeleton_50'),
    buyAmountMinusFeeAmount: labelTextSkeleton('skeleton_50'),
    companyName: labelTextSkeleton('skeleton_50'),
  },
};
